"use client";

import { Box, Typography } from "@mui/material";
import { HUB_BREADCRUMBS, HubBreadcrumbs } from "../HubBreadcrumbs";
import { HubListingArticle } from "../HubListingArticle";
import { Article } from "../articles/Article";
import { CollectionPage, Graph } from "schema-dts";

export function HubGuidesPage({ articles }: { articles: Article[] }) {
  const collectionPageSchema: CollectionPage = {
    name: "Horsezone Hub Guides",
    description: "Guides for buying, selling and caring for horses.",
    "@type": "CollectionPage",
    mainEntity: articles.map((article) => ({
      "@type": "Article",
      headline: article.title,
      datePublished: article.createdAt.iso,
      dateModified: article.createdAt.iso,
      url: `https://horsezone.com.au/hub/guides/${article.slug}`,
      description: article.preview,
    })),
  };
  const graphSchema: Graph = {
    "@context": "https://schema.org",
    "@graph": [collectionPageSchema],
  };
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: "grey.200",
        paddingTop: 2,
        paddingBottom: 8,
        minHeight: "100%",
        [theme.breakpoints.down("sm")]: {
          backgroundColor: "white",
        },
      })}
    >
      <Box
        sx={{
          maxWidth: "800px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <HubBreadcrumbs
          breadcrumbs={[HUB_BREADCRUMBS.hub, HUB_BREADCRUMBS.guides]}
        />
        <Typography
          variant="h4"
          component="h1"
          sx={(theme) => ({
            padding: theme.spacing(0, 4),
            [theme.breakpoints.down("sm")]: {
              padding: theme.spacing(0, 2),
            },
          })}
        >
          Guides
        </Typography>
        <Box
          sx={(theme) => ({
            padding: 4,
            borderRadius: 10,
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            gap: 4,
            [theme.breakpoints.down("sm")]: {
              padding: 2,
              borderRadius: 0,
            },
          })}
        >
          {articles.map((article) => (
            <HubListingArticle key={article.slug} article={article} />
          ))}
        </Box>
      </Box>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(graphSchema) }}
      />
    </Box>
  );
}
